export const PLACEHOLDER_PATTERN = /\{\{\s*([a-z][a-z0-9_]*\.[a-z][a-z0-9_]*)\s*\}\}/g;

export function extractPlaceholderKeys(bodyHtml: string): string[] {
  const keys = new Set<string>();
  for (const match of bodyHtml.matchAll(PLACEHOLDER_PATTERN)) {
    keys.add(match[1]);
  }
  return [...keys];
}

export function findUnknownPlaceholders(bodyHtml: string, knownKeys: readonly string[]): string[] {
  const known = new Set(knownKeys);
  return extractPlaceholderKeys(bodyHtml).filter((key) => !known.has(key));
}
